// extracted by mini-css-extract-plugin
module.exports = {"container":"socialbutton-module--container--2NQMJ","icon":"socialbutton-module--icon--2bAE8"};